import "./style.scss";
import { useState } from "react";
import AOPConfig from "./AOPConfig/AOPConfig";
import AOPPrev from "./AOPPrev/AOPPrev";
import { AOPMaltaCertificateData } from "@/src/types/admissionOffice";

const AOPMaltaCertificateLayout = () => {
  const [certificateInfo, setCertificateInfo] = useState<string>("");

  const [dataForGeneration, setDataForGeneration] = useState<AOPMaltaCertificateData>({
    currentDate: "",
    fullName: "",
    body: [],
    userOffice: "01",
    whose_doc: "",
  });

  const [bodyForPrev, setBodyForPrev] = useState<AOPMaltaCertificateData>({
    currentDate: "",
    fullName: "",
    body: [],
    userOffice: "01",
    whose_doc: "",
  });

  return (
    <>
      <div className="container admission-office-page">
        <AOPConfig
          dataForGeneration={dataForGeneration}
          setDataForGeneration={setDataForGeneration}
          setBodyForPrev={setBodyForPrev}
          setCertificateInfo={setCertificateInfo}
        />
        <AOPPrev bodyForPrev={bodyForPrev} certificateInfo={certificateInfo} />
      </div>
    </>
  );
};

export default AOPMaltaCertificateLayout;
